import React, { useEffect, useState } from 'react'
import { Button, Form, Input } from 'semantic-ui-react'
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import firebase from '../../config/fbConfig'
import './Contact.scss'
import { sendMessageToSupport } from '../../redux/actions/user';
import { toast } from 'react-toastify';

const Contact = () => {

    const [user, setUser] = useState(null)
    const [values, setValues] = useState({})

    useEffect(() => {
        loadUser()
    }, [user])

    const loadUser = async () => {
        const currentUser = await firebase.auth().currentUser;
        if(currentUser) {
            setUser(currentUser.email)
        }
    }

    const handleOnChange = e => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleOnSubmit = async e => {
        e.preventDefault();
        // Enviamos la información del problema a soporte
        toast.info('Enviando mensaje...', {
            position: "top-center",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
        const response = await sendMessageToSupport(values)
        if(response && response.status) {
            toast.success('Mensaje enviado correctamente, en las próximas 24 horas tendrá una respuesta', {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }
        if(response && response.error) {
            toast.error(response.error.message, {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })
        }
    }

    return (
        <div className='contact'>

            <div className='contact_description'>
                <SupportAgentIcon style={{ fontSize: '50px', color: '#68bbe3' }} />
                <h2 style={{ color: '#68bbe3' }}>Cuéntanos tu problema y trataremos de resolverlo lo antes posible</h2>
                <div className='contact_description_content'>
                    <h3>Información de contacto</h3>
                    <div className='contact_description_content_item'>
                        <b>Email: </b>
                        <span>support@shield-data.com</span>
                    </div>
                    <div className='contact_description_content_item'>
                        <b>Teléfono: </b>
                        <span>+33 786 85 66 03</span>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Contact
